<template>
  <div class="new-messenger-container">
    <b-loading :is-full-page="false" :active="!$store.state.websocket.isWebSocketConnection" />
    <div class="new-messenger" :class="[`mode-${mode}`, `conversation-details-${conversationDetails}`]">
      <div class="new-messenger-tickets">
        <new-messenger-tickets
          v-if="isSeller()"
          ref="ticketsList"
          :tickets="tickets"
          :unread-messages="unreadMessages"
          @changeFilter="changeFilter"
          @reloadTicketList="getTicketList"
          @enterConversation="changeMode($event)"
          @loadMoreTickets="loadMoreTickets()"
        />
        <new-messenger-tickets-client
          v-else
          ref="ticketsList"
          :tickets="tickets"
          :unread-messages="unreadMessages"
          @enterConversation="changeMode($event)"
          @loadMoreTickets="loadMoreTickets()"
        />
      </div>
      <div class="new-messenger-conversation">
        <b-loading :is-full-page="false" :active="$store.state.websocket.loadingTicket" />
        <template v-if="mode === 'conversation' && ticket && ticket.id">
          <div class="conversation-title">
            <div class="truncated">
              <template v-if="ticket?.title">
                {{ ticket.title }}
              </template>
            </div>
            <div class="buttons">
              <b-button icon-left="arrow-left" class="conversation-details-icon" @click="changeMode()" />
              <b-button
                icon-left="information"
                class="conversation-details-icon"
                @click="toggleConversationDetails(true)"
              />
            </div>
          </div>
          <new-messenger-conversation
            v-if="isSeller()"
            ref="conversationComponent"
            :ticket="ticket"
            :is-typing="isTyping"
            :messages="messages"
            @switchTicketLanguage="switchTicketLanguage"
            @loadMoreMessages="loadMoreMessages"
            @addMessage="addMessageToList"
          />
          <new-messenger-conversation-client
            v-else
            ref="conversationComponent"
            :ticket="ticket"
            :is-typing="isTyping"
            :messages="messages"
            @switchTicketLanguage="switchTicketLanguage"
            @loadMoreMessages="loadMoreMessages"
            @addMessage="addMessageToList"
          />
        </template>
        <template v-if="mode === 'tickets'">
          <div class="conversation-choose-ticket">
            <conversation-choose-ticket-svg />
            <div>
              {{ $t('newMessenger.selectTicketFromTheList') }}
            </div>
          </div>
        </template>
      </div>
      <template v-if="mode === 'conversation' && ticket && ticket.id">
        <div v-if="isSeller()" class="new-messenger-details">
          <new-messenger-conversation-details
            ref="conversationDetailsSeller"
            :ticket="ticket"
            @closeDetails="toggleConversationDetails(false)"
            @closeTicket="closeTicket"
          />
        </div>
        <div v-else class="new-messenger-details">
          <new-messenger-conversation-details-client
            :ticket="ticket"
            @closeDetails="toggleConversationDetails(false)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import NewMessengerConversation from './seller/NewMessengerConversation'
import NewMessengerConversationClient from './client/NewMessengerConversation'
import NewMessengerConversationDetails from './seller/NewMessengerConversationDetails'
import NewMessengerConversationDetailsClient from './client/NewMessengerConversationDetails'
import NewMessengerTickets from './seller/NewMessengerTickets'
import NewMessengerTicketsClient from './client/NewMessengerTickets'
import ConversationChooseTicketSvg from '~/marketplace-front-core/assets/illustrations/conversation-choose-ticket.svg?inline'

export default {
  name: 'NewMessenger',
  components: { NewMessengerTickets, NewMessengerConversation, NewMessengerConversationDetails, ConversationChooseTicketSvg, NewMessengerTicketsClient, NewMessengerConversationClient, NewMessengerConversationDetailsClient },
  data () {
    return {
      mode: 'tickets',
      conversationDetails: false,
      ticket: null,
      loadingTicketId: null,
      tickets: [],
      messages: [],
      isTyping: false,
      unreadMessages: 0,
      lastTicketReached: false,
      lastMessageReached: false,
      filter: null,
      limitTicketList: 20,
      typeRoom: ['user', 'store', 'op', 'order'],
      firstInitMessenger: true,
      divHeightBeforeScroll: 0
    }
  },
  watch: {
    '$store.state.websocket.isWebSocketConnection': {
      handler (isConnect) {
        if (isConnect) {
          this.init()
        }
      }
    },
    '$route.query': {
      immediate: true,
      deep: true,
      handler (newQuery) {
        this.changeMode(newQuery && newQuery.ticketId ? newQuery.ticketId : null)
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.$nuxt.$store.state.websocket.isWebSocketConnection) {
        this.$nextTick(() => {
          this.setOnMessage()
        })
        this.$nextTick(() => {
          const query = this._clone(this.$route.query)

          this.getTicketList()

          if (query.typeId !== '' && this.typeRoom.includes(query.type)) {
            this.$store.dispatch('websocket/createRoom', { type: query.type, id: query.typeId })
            delete query.type
            delete query.typeId
            this.$router.replace({ query })
          }
        })
      }
    },
    isSeller () {
      if (this._user) {
        const check = ['ROLE_SELLER_OWNER', 'ROLE_SELLER'].filter(val =>
          this._user.roles.includes(val)
        )

        return check.length
      }
      return false
    },
    setOnMessage () {
      this.$store.state.websocket.webSocket.onmessage = (message) => {
        const data = (JSON.parse(message.data))
        console.log(`%c${this._currentTime} %cGET FROM API:%c ${data.type}`, 'color: #C4EFD8;', 'background: #30714E; font-size: 0.75rem; color: #C4EFD8;', 'color: #C4EFD8;', data)
        switch (data.type) {
          case 'message':
            this.addMessageToList(data)
            break
          case 'message-history':
            this.addMessageHistoryToList(data)
            this.$store.dispatch('websocket/changeLoadingMessageMore', false)
            break
          case 'count-unread':
            this.unreadMessage(data)
            break
          case 'user-started-typing':
            this.startTyping()
            break
          case 'user-stopped-typing':
            this.stopTyping()
            break
          // case 'check-ticket-list':
          //   this.checkTicketList(data)
          //   break
          case 'ticket-list':
            this.setTicketsList(data)
            this.$store.dispatch('websocket/changeLoadingTicketList', false)
            this.$store.dispatch('websocket/changeLoadingTicketListMore', false)
            break
          case 'ticket-data':
            this.stopTyping()
            this.setTicket(data)
            this.$store.dispatch('websocket/changeLoadingTicket', false)
            this.$store.dispatch('websocket/changeLoadingCloseTicket', false)
            this.$store.dispatch('websocket/changeLoadingAssignEmployees', false)
            break
          case 'info-ticket-data':
            this.setNewTicket(data)
            this.$store.dispatch('websocket/changeLoadingCreateTicket', false)
            break
          case 'JWT-token-info':
            //   this.refreshToken(data)
            break
          case 'assign-order':
            this.assignOrder(data)
            this.$store.dispatch('websocket/changeLoadingChangeOrderId', false)
            break
          case 'eventLeft':
            this.addMessageToList(data)
            break
          case 'eventJoined':
            this.addMessageToList(data)
            break
          case 'message-error':
            this.handleMessageError(data)
            break
          case 'employees-online':
            this.changeEmployeesOnline(data)
            break
          default:
            console.warn(`${this._currentTime} UNKNOWN TYPE: `, data.type, data)
        }
      }
    },
    setTicketsList (data) {
      this.lastTicketReached = data.ticketList.lastTicketReached
      this.$refs.ticketsList.setLoadTickets(false)

      if (data.ticketList.firstPage) {
        this.tickets = []
      }

      if (this.tickets.length) {
        const ids = this.tickets.map(x => x.id)
        const newTickets = data.ticketList.elements.filter(x => !ids.includes(x.id))
        this.tickets = [...this.tickets, ...newTickets]
      } else {
        this.tickets = data.ticketList.elements
      }

      if (this.firstInitMessenger) {
        const query = this.$route.query
        if (query.ticketId) {
          this.changeMode(query.ticketId)
        }
        this.firstInitMessenger = false
      }
    },
    assignOrder (data) {
      this.$refs.conversationDetailsSeller.validationAssignOrder(data.message)

      if (data.message === 'TICKET_UPDATED') {
        this.$store.dispatch('websocket/ticketData', this.ticket.id)
      }
    },
    setTicket (data) {
      this.ticket = data

      this.$nextTick(() => {
        if (this.$refs.conversationComponent) {
          this.$refs.conversationComponent.scrollToBottom()
        }
      })
    },
    addMessageToList (data) {
      if (this.mode === 'conversation') {
        // Weryfikacja do usunięcia loadingu wiadomości
        if (data.id && data.type === 'message') {
          let findIndex = null
          if (data.files && data.files.length) {
            findIndex = this.messages.findIndex(x =>
              x.message === data.message &&
              x.loading &&
              x.files &&
              x.files.length &&
              JSON.stringify(x.files.map(x => x.id)) === JSON.stringify(data.files.map(x => x.id))
            )
          } else {
            findIndex = this.messages.findIndex(x =>
              x.message === data.message &&
              x.loading
            )
          }

          if (findIndex >= 0) {
            this.$delete(this.messages, findIndex)
          }
        }
        this.messages.push(data)

        this.$nextTick(() => {
          if (this.$refs.conversationComponent) {
            this.$refs.conversationComponent.scrollToBottom()
          }
        })
      }
    },
    setNewTicket (data) {
      if (data.newTicketId) {
        this.changeMode(Number(data.newTicketId))

        const isExistNewTicket = this.tickets.find(element => element.id === data.newTicketId)
        if (!isExistNewTicket) {
          this.tickets.unshift(data.ticketData)
        }
      } else {
        const index = this.tickets.findIndex(obj => obj.id === data.ticketData.id)

        if (data.onTop) {
          if (index > -1) {
            if (this.ticket) {
              this.ticket.status = data.ticketData.status ? data.ticketData.status : 'OPEN'
            }

            this.tickets.splice(index, 1)
          }
          this.tickets.unshift(data.ticketData)
        } else if (index > -1) {
          this.tickets[index] = Object.assign(this.tickets[index], data.ticketData)
        }
      }
    },
    unreadMessage (data) {
      this.unreadMessages = data.unreadTickets

      this.$store.dispatch('websocket/unreadMessage', data)
    },
    startTyping () {
      if (this.mode === 'conversation') {
        this.isTyping = true
        this.$nextTick(() => {
          this.$refs.conversationComponent.scrollToBottom()
        })
      }
    },
    stopTyping () {
      this.isTyping = false
    },
    closeTicket () {
      this.$store.dispatch('websocket/closeRoom', this.ticket.id)
    },
    addMessageHistoryToList (data) {
      this.lastMessageReached = data.lastMessageReached
      const scroll = this.messages === 0
      const ids = this.messages.map(x => x.id)
      const newMessages = data.messages.filter(x => !ids.includes(x.id))

      this.messages = [...newMessages, ...this.messages]

      this.$nextTick(() => {
        if (this.$refs.conversationComponent && this.$refs.conversationComponent.$refs.conversationMessages) {
          const conversationMessages = this.$refs.conversationComponent.$refs.conversationMessages
          conversationMessages.scrollTop = conversationMessages.scrollHeight - this.divHeightBeforeScroll
        }
      })
      if (this.mode === 'conversation' && scroll) {
        this.$nextTick(() => {
          if (this.$refs.conversationComponent) {
            this.$refs.conversationComponent.scrollToBottom()
          }
        })
      }
    },
    loadMoreTickets () {
      if (!this.lastTicketReached) {
        this.getTicketList()
      }
    },
    changeFilter (filter) {
      this.filter = filter
    },
    getTicketList (newTicketList) {
      this.$store.dispatch('websocket/ticketsList', { ...this.filter, ...this.additionalFilter(newTicketList) })
    },
    additionalFilter (newTicketList) {
      const query = this.$route.query
      return {
        requiredId: query.ticketId ? query.ticketId : 0,
        ticketsCount: newTicketList ? 0 : this.tickets.length,
        limit: this.limitTicketList
      }
    },
    loadMoreMessages (id) {
      if (!this.lastMessageReached) {
        const conversationMessages = this.$refs.conversationComponent.$refs.conversationMessages
        this.divHeightBeforeScroll = conversationMessages.scrollHeight
        this.$store.dispatch('websocket/loadMoreMessages', { lastMessageId: id })
      }
    },
    switchTicketLanguage (lang) {
      this.ticket.lang = lang
    },
    changeMode (ticketId = null) {
      const query = this._clone(this.$route.query)

      if (ticketId) {
        if (!((this.ticket && this.ticket.id === Number(ticketId)) || this.loadingTicketId === Number(ticketId))) {
          this.messages = []
          this.loadingTicketId = Number(ticketId)
          this.$store.dispatch('websocket/connectToRoom', { ticketId: Number(ticketId), ticketsCount: 0 })

          this.conversationDetails = false
          this.mode = 'conversation'

          query.ticketId = ticketId

          if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
            this.$router.push({ query })
          }
        }
      } else {
        this.loadingTicketId = null
        this.mode = 'tickets'
        this.ticket = null

        delete query.ticketId

        if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
          this.$router.push({ query })
        }
      }
    },
    changeEmployeesOnline (data) {
      if (this.ticket && data) {
        this.ticket.employeesOnline = data.clients
      }
    },
    toggleConversationDetails (state) {
      this.conversationDetails = state
    },
    handleMessageError (data) {
      this.changeMode()
      switch (data.message) {
        case 'TICKET_NOT_EXIST':

          break
        case 'STORE_ACCESS_DENIED':

          break
        case 'ACCESS_DENIED':

          break
        case 'TICKET_IS_NOT_OPEN':

          break

        default:
          console.error('Error message: ', data)
      }
    }
    // async refreshToken (data) {
    //   this.mode = 'tickets'
    //   this.$store.dispatch('websocket/close')
    //   await this.$api.auth.refreshToken(this.$store.state.auth.refreshToken)
    //     .then((res) => {
    //       this.$store.dispatch('auth/set', res)
    //     }).then(() => {
    //       setTimeout(() => {
    //         this.initWebSocket()
    //         this.setOnMessage()
    //         this.$store.dispatch('websocket/ticketsList', this.filter)
    //       }, '5000')
    //     })
    // }
  }
}
</script>

<style lang="scss" scoped>
$messenger-border-color: #E7E8E7;
$messenger-conversation-bg-color: #F8F8F8;

.truncated {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new-messenger {
  display: flex;
  height: 100%;
  border: 1px solid $messenger-border-color;
  border-radius: 6px;
  overflow: hidden;

  @include touch {
    border: 0;
    border-radius: 0;
    border-top: 1px solid $messenger-border-color;
  }

  &.mode-tickets {
    @include touch {

      .new-messenger-conversation,
      .new-messenger-details {
        display: none;
      }
    }
  }

  &.mode-conversation {
    @include touch {

      .new-messenger-tickets,
      message .new-messenger-details {
        display: none;
      }

      .conversation-title {
        display: flex !important;
        .buttons {
          flex-shrink: 0;
        }
      }
    }
  }
  &.conversation-details-false .new-messenger-details {
    @include touch {
      display: none;
    }
  }
  &.conversation-details-true {
    @include touch {
      .new-messenger-conversation {
        display: none;
      }

      .new-messenger-details, .conversation-details {
        display: block !important;
      }
    }
  }

  .new-messenger-tickets {
    position: relative;
    flex-shrink: 0;
    width: 250px;

    @include touch {
      width: 100vw;
      //max-width: calc(100vw - 50px - 2px);
    }
  }

  .new-messenger-conversation {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    @include fullhd {
      max-width: calc(1344px - 500px);
    }
    @include widescreen-only {
      max-width: calc(1152px - 500px);
    }
    @include desktop-only {
      max-width: calc(960px - 500px);
    }
    background-color: $messenger-conversation-bg-color;
    border-right: 1px solid $messenger-border-color;
    border-left: 1px solid $messenger-border-color;

    @include touch {
      width: 100vw;
      border: 0;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }

    .conversation-choose-ticket {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      width: 100%;
      height: 100%;
      color: rgba($text_color, 0.5);

      :deep(svg) {
        max-width: 200px;
        height: auto;
      }
    }

    .conversation-title {
      display: none;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      height: 64px;
      padding: 0 16px;
      background-color: white;
      border-bottom: 1px solid $messenger-border-color;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      font-weight: 600;

      @include touch {
        font-size: 20px;
      }

      .conversation-details-icon {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 20px;
        border: 0;

        :deep(.icon)>i {
          font-size: 18px !important;
        }
      }
    }
  }

  .new-messenger-details {
    position: relative;
    flex-shrink: 0;
    width: 250px;
    overflow: hidden;

    @include touch {
      width: 100%;
    }
  }
}

// .test-viewport {
//   position: fixed;
//   top: 50%;
//   left: 50%;
//   padding: 16px;
//   z-index: 100;
//   background-color: white;
// }
</style>
